import * as React from "react";
import { resolveInject } from "./di";
import { IAppConfigProvider } from "./services/config/app-config-loader.service";

interface ThemeProviderProps {
    children: React.ReactNode;
}

interface StylingProps extends React.CSSProperties {}

export const ThemeContext = React.createContext<any>(null);

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
    const appConfig = resolveInject(IAppConfigProvider).config;

    const [cssProperties, setCssProperties] = React.useState<React.CSSProperties>({});

    React.useEffect(() => {
        const styling = appConfig.styling;
        if (styling) {
            setCssProperties(styling);
        }
    }, []);

    return (
        <ThemeContext.Provider value={{ cssProperties, setCssProperties }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const val = React.useContext(ThemeContext);
    if (val === undefined) throw new Error("Context is undefined");
    return val;
};

export default ThemeProvider;
